import { useState } from "react";
import useCreate from "../useCreate";
import toast from "react-hot-toast";

const useDeleteAttribute = () => {
  const [attributeId, setAttributeId] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const { setDataToServer: deleteAttribute } = useCreate({
    refreshUrl: "product/attribute-value/list",
    url: "product/attribute-value/delete",
    onSuccess: () => {
      toast.success("Attribute Deleted Successfully");
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Error Deleting Attribute");
    },
  });

  const handleSubmit = (data) => {
    deleteAttribute.mutate(data);
    setDeleteModalOpen(false);
  };

  return {
    attributeId,
    setAttributeId,
    isDeleteModalOpen,
    setDeleteModalOpen,
    handleSubmit,
  };
};

export default useDeleteAttribute;
